/** 搜索输入地址的  input **/
<template>
  <div class="siteInput">
    {{ nameFn }}
    <input v-if="name" class="siteInputShow" @click="queryShowFn" readonly="readonly" v-model="query">
    <span v-else class="siteInputShow placeholder" @click="queryShowFn">{{placeholder}}</span>
    <div class="result " :class="resultState?'showResult':''" @touchstart="resultFn">
      <div class="Title">
        <div class="selectCity" :class="acCityState?'selectCityShow':''" @click="cityAcFn">
          <span class="city">{{cityShow}}</span>
          <span class="icon">
            <i class="iconfont icon-jiantou"></i>
          </span>
        </div>
        <input v-model="query" @input="mapFn(query,'input')" :placeholder="placeholder" @click.stop="mapFn(query)"
               ref="queryInput"/>
        <span class="closeBut" @click.stop="moduleFn">
          取消
        </span>
      </div>
      <div class="shortcut clear" v-if="!acCityState">
        <div class="shortcut-row" v-for="(item,index) in shortcutData" :class="{'shortcut-row-ac':shortcutAc===item}"
             @click="shortcutClickFn(item)">
          {{item}}
        </div>
      </div>
      <div class="cityMod" ref="cityMod" v-if="acCityState">
        <div class="hotCity">
          <div class="cityRow">
            <div class="title clear">
              <div class="Left">
                <i class="iconfont icon-xing"></i>
                <span>热门城市</span>
              </div>
              <div class="Right" @click="acCityFn(positioning.city)">
                <i class="iconfont icon-dingwei"></i>
                <span>{{positioning.name !== '获取定位失败'&&positioning.city ?positioning.city: '定位失败'}}</span>
              </div>
            </div>
            <div class="content">
              <ul>
                <li v-for="(item,index) in hotCity" @click="acCityFn(item)">
                  {{item}}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="cityList">
          {{getCityFn}}
          <div class="cityRow" v-for="(item,index) in getCity" ref="cityRow">
            <div class="title">
              {{item.letter}}
            </div>
            <div class="content">
              <ul>
                <li v-for="(key,index) in item.content" @click="acCityFn(key.name)">
                  {{key.name}}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="replaceCityList" v-if="acCityState">
        <ul @touchmove="replaceCityListFn">
          <li v-for="(item,num,index) in getCity"
              :class="acCityIndex===index?'ac':''"
              @click="vibrationFn(index)"
              ref="replaceCityItem">
              <span class="">
              {{item.letter}}
              </span>
          </li>
        </ul>
      </div>
      <div class="searchMod">
        <div class=" resultCont addressRecord" v-if="query === '' && addressrecord && addressrecord.length>0">
          <ul>
            <li v-for="(item,index) in addressrecord" @click.stop="actionFn(item.address)">
              <h3>{{item.address.name}}</h3>
              <p>{{item.address.detailedAddress}}</p>
            </li>
          </ul>
        </div>
        <div class="resultCont" v-if="(query!==''||shortcutAc!=='')&&result.length>0">
          <ul>
            <li v-for="(item, index) in result" @click.stop="actionFn(item)">
              <h3>{{item.name}}</h3>
              <p>{{item.detailedAddress}}</p>
            </li>
          </ul>
        </div>
        <div v-else-if="query!=='' && result.length<=0" class="without">
          没有信息
        </div>
      </div>
    </div>
    <div class="module" :class="resultState?'moduleShow':''" @click="moduleFn"></div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  //  import Toucth from '../../../../assets/js/method'

  export default {
    name: 'xk-siteInput',
    props: ['placeholder', 'name', 'city', 'state', 'addressrecord', 'checkedlogin'],
    computed: {
      ...mapGetters({
        mapState: 'mapState',
        getCity: 'getCity',
        positioning: 'positioning'
      }),
      /**
       * 定位地址
       */
      nameFn: function () {
        this.query = this.name
        this.recordQuery = this.name
      },
      getCityFn: function () {
      }
    },
    data () {
      return {
        query: '',
        recordQuery: '',
        result: [],
        shortcutData: [
          '娱乐',
          '商城',
          '餐馆',
          '旅游',
          '学校'
        ],
        shortcutAc: this.query || '娱乐',
        hotCity: [
          '北京',
          '广州',
          '上海',
          '深圳',
          '成都'
        ],
        resultState: false,
        acCityIndex: 0,
        acCityState: false,
        cityShow: '',
        addsJL: null
      }
    },
    watch: {
      positioning: function (val) {
        if (val && !this.$props.city) {
          this.cityShow = val.city ? val.city : '成都市'
        }
      },
      city: function (val) {
        var that = this
        if (val) {
          that.cityShow = val.replace('市', '')
        }
      }
    },
    methods: {
      mapFn: function (adds, type) {
        let that = this
        if (type === 'input') {
          that.shortcutAc = ''
        }
        if (that.addsJL === adds) {
          return
        }
        that.addsJL = adds
        if (that.mapState === 'google') {
          that.$store.dispatch('googleMapSite', {
            query: adds || that.query,
            fn: (data) => {
              that.result = data
            }
          })
        } else {
          that.$store.dispatch('amapMapSite', {
            query: adds || that.query,
            city: that.cityShow !== '选择城' ? that.cityShow : '',
            fn: (data) => {
              // console.log('地址搜索结果', data)
              that.result = data
            }
          })
        }
      },
      shortcutClickFn (adds) { // 推荐 点击
        this.shortcutAc = adds
        this.query = ''
        this.mapFn(adds)
      },
      actionFn: function (obj) {
        this.resultState = false
        this.query = obj.name
        this.recordQuery = obj.name
        this.$emit('onClick', obj)
      },
      moduleFn: function () {
        this.resultState = false
        this.query = this.recordQuery
        this.acCityState = false
      },
      queryShowFn: function () {
        let that = this
        let fn = () => {
          if (!that.$props.state) {
            that.$emit('onClick')
            return false
          }
          if (that.$props.name === '') {
            that.result = []
          }
          if (that.query !== '') {
            that.shortcutAc = ''
          }
          document.body.scrollTop = 0
          that.resultState = true
          that.$refs.queryInput.focus()
          that.mapFn(that.query || that.shortcutAc)
        }
        if (this.checkedlogin || this.checkedlogin === '') {
          this.$store.dispatch('checkLogin', (state) => {
            if (state) {
              fn()
            } else {
              console.log('点击终点', this.checkedlogin)
              that.$router.push('/login')
              that.$store.dispatch('loginAction', {state: false})
            }
          })
        } else {
          fn()
        }
      },
      resultFn: function () {
        this.$refs.queryInput.blur()
      },
      replaceCityListFn: function (e) { // 城市滑动选择
        let that = this
        let Y = e.touches[0].clientY
        let Item = that.$refs.replaceCityItem
        for (let i = 0; i < Item.length; i++) {
          if (Y >= (Item[i].offsetTop + 110) && Item[i + 1] && Y < (Item[i + 1].offsetTop + 110)) {
            this.acCityIndex = i
            that.cityModScorllFn()
            return
          }
          if (!Item[i + 1] && Y >= (Item[i].offsetTop + 110)) {
            this.acCityIndex = i
            that.cityModScorllFn()
          }
        }
      },
      vibrationFn: function (index) {
        var that = this
        that.acCityIndex = index
        that.cityModScorllFn()
      },
      cityModScorllFn: function () {
        let that = this
        let cityMod = that.$refs.cityMod
        let cityRowS = that.$refs.cityRow
        if (cityRowS && cityRowS.length > 0) {
          for (let i = 0; i < cityRowS.length; i++) {
            if (that.acCityIndex === i) {
              cityMod.scrollTop = cityRowS[i].offsetTop
            }
          }
        }
      },
      cityAcFn: function () {
        this.acCityState = !this.acCityState
      },
      acCityFn: function (city) {
        if (city && city.indexOf('市') > 0) {
          city = city.replace('市', '')
        }
        this.cityAcFn()
        this.cityShow = city + '市'
        this.mapFn(this.query || this.shortcutAc)
      }
    },
    mounted: function () {
      var that = this
      setTimeout(() => {
        if (that.$props.city) {
          that.cityShow = that.$props.city.replace('市', '')
        } else if (that.positioning && that.positioning.lat && that.positioning.lng) {
          that.cityShow = that.positioning.city ? that.positioning.city : '成都市'
        }
      }, 200)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .siteInput {
    width: 100%;
    height: 100%;
    position: relative;
    .siteInputShow {
      position: absolute;
      left: 0;
      top: 0;
      display: inline-block;
      border: none;
      width: 100%;
      font-size: 1.1666rem;
      height: 3.1666rem;
      z-index: 5;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .placeholder {
      width: 100%;
      color: #999;
    }
    .without {
      text-align: center;
      margin-top: 2rem;
    }
    .result {
      position: fixed;
      height: 100%;
      top: 150%;
      left: 0;
      background-color: #f3f4f5;
      width: 100%;
      border-radius: 0.333rem;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      z-index: -100;
      opacity: 1;
      overflow: hidden;
      overflow-y: auto;
      line-height: 1.5rem !important;
      transition: 0.3s all;
      .Title {
        display: inline-block;
        height: 3.5rem;
        line-height: 3.5rem;
        width: 100%;
        max-width: none;
        position: relative;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        background: #fff;
        z-index: 80;
        .selectCity {
          float: left;
          box-sizing: border-box;
          padding-right: 0.5rem;
          width: 6.5rem;
          height: inherit;
          line-height: 3.5;
          text-align: center;
          position: relative;
          .city {
            box-sizing: border-box;
            display: inline-block;
            width: 5rem;
            margin-right: 0.5rem;
            height: inherit;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 1rem;
          }
          .icon {
            position: absolute;
            right: 0.5rem;
            top: 50%;
            width: 1.2rem;
            height: 1.2rem;
            transform: translate(0, -50%);
            i {
              font-size: 0.8rem;
              position: absolute;
              left: 50%;
              top: 50%;
              transition: 0.3s all;
              transform: translate(-50%, -50%) rotate(90deg);
              color: #666;
              margin: 0;
            }
          }
        }
        .selectCity::after {
          content: '';
          width: 1px;
          height: 50%;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
          background: #eee;
        }
        .selectCityShow {
          .icon {
            i {
              transform: translate(-50%, -50%) rotate(-90deg);
            }
          }
        }
        input {
          margin-top: 0.2rem;
          box-sizing: border-box;
          display: inline-block;
          width: calc(~'100% - 10rem') !important;
          border: none;
          font-size: 1.1666rem;
          position: relative;
          z-index: 5;
          padding: 0.5rem;
        }
        .closeBut {
          position: absolute;
          right: 0.5rem;
          top: 0;
          z-index: 50;
          color: #666;
        }
      }
      .resultCont {
        box-sizing: border-box;
        width: 100%;
        padding: 0 1rem 0 1rem;
        margin-top: 1rem;
        overflow: hidden;
        overflow-y: scroll;
        height: calc(~'100% - 3.5rem');
        ul {
          box-shadow: 0 0 10px rgba(0, 0, 0, .1);
          border-radius: 0.333rem;
        }
        p {
          color: #bbb;
        }
        .without {
          width: 100%;
        }
        li {
          padding: 0.3rem 1rem;
          border-bottom: 1px solid #eee;
          background: #fff;
          h3 {
            font-weight: normal;
            margin-bottom: 0.4rem;
            margin-top: 0.5rem;
            font-size: 1.2rem;
          }
          p {
            margin: 0.4rem 0;
          }
        }
        li:nth-last-child(1) {
          border-bottom: none;
        }
      }
    }
    .showResult {
      z-index: 600;
      opacity: 1;
      top: 0;
    }
    .module {
      display: block;
      position: fixed;
      left: 50%;
      top: 50%;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0);
      transform: translate(-50%, -50%);
      opacity: 1;
      z-index: -100;
    }
    .moduleShow {
      opacity: 0;
      z-index: 50;
    }
    .cityMod {
      width: 100%;
      height: calc(~'100vh - 3.5rem');
      overflow-y: scroll;
      position: relative;
      z-index: 20;
      .cityList, .hotCity {
        .cityRow {
          width: 100%;
          box-sizing: border-box;
          padding: 0.5rem 1rem;
          .title {
            box-sizing: border-box;
            text-align: left;
            width: 100%;
            padding: 0 1rem;
            max-width: none !important;
            font-size: 1.2rem;
            border-radius: 0.333rem 0.333rem 0 0;
            background: #fff;
            i {
              color: #f06553;
            }
          }
          .content {
            box-sizing: border-box;
            width: 100%;
            padding: 0 1rem;
            text-align: left;
            background: #fff;
            border-radius: 0 0 0.333rem 0.333rem;
            ul {
              li {
                width: 100%;
                box-sizing: border-box;
                padding: 0 0.5rem;
                line-height: 3rem;
                border-bottom: 1px solid #eee;
                color: #666;
              }
              li:nth-last-child(1) {
                border-bottom: none;
              }
            }
          }
        }
      }
      .hotCity {
        padding-top: 0.5rem;
        .Left {
          float: left;
          font-size: 1rem;
          i {
            line-height: 2.3;
            color: #f06553;
          }
        }
        .Right {
          float: right;
          font-size: 0.833rem;
          i {
            line-height: 2;
            color: #666;
          }
        }
      }
    }
    .replaceCityList {
      position: fixed;
      right: 0;
      top: 0;
      height: 100vh;
      width: 2rem;
      z-index: 30;
      ul {
        position: absolute;
        top: 50%;
        right: 0;
        width: inherit;
        transform: translate(0, -50%);
        background: rgba(0, 0, 0, .1);
        border-radius: 0.333rem 0 0 0.333rem;
        overflow: hidden;
        li {
          box-sizing: border-box;
          width: inherit;
          text-align: center;
          line-height: 1.6rem;
          height: 1.6rem;
          float: none;
          transition: 0.3s all;
          position: relative;
          span {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: rgba(0, 0, 0, .2);
            font-weight: 400;
            transition: 0.3s all;
          }
        }
        .ac {
          background: #f06553 !important;
          span {
            color: #fff !important;
          }
        }
      }
    }
    .shortcut {
      background: #fff;
      .shortcut-row {
        float: left;
        box-sizing: border-box;
        line-height: 3.6rem;
        height: 3.2rem;
        text-align: center;
        color: rgba(0, 0, 0, .5);
        width: 20%;
        position: relative;
      }
      .shortcut-row + .shortcut-row::after {
        position: absolute;
        content: '';
        height: 1rem;
        width: 1px;
        background: #eee;
        display: inline-block;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
      .shortcut-row-ac {
        color: #f06553;
      }
    }
  }

  @media screen and (max-width: 375px) {
    html {
      .siteInput .replaceCityList ul {
        top: 55%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// siteInput.vue?463c242c